module.exports = __webpack_public_path__ + "img/nojc.2668f09f.png";